import { SystemManager } from "./system-manager.js"
import { MODULE, REQUIRED_CORE_MODULE_VERSION } from "./constants.js"

Hooks.on("tokenActionHudCoreApiReady", async () => {
	/**
	 * Return the SystemManager and requiredCoreModuleVersion to Token Action HUD Core
	 */
	const module = game.modules.get(MODULE.ID)
	module.api = {
		requiredCoreModuleVersion: REQUIRED_CORE_MODULE_VERSION,
		SystemManager,
	}
	Hooks.call("tokenActionHudSystemReady", module)
})
